/**
 * 派单方式(L0-05)。**单点定义在这里,三端引用。**
 *
 *   designated  客户指定承运商直派 —— 下单即知道是哪家,所以佣金率**下单时**就快照(M-11)
 *   pool        放订单池 —— 先进平台自营的优先窗口,窗口过后公开,由飞手个人抢单
 *
 * 这两个取值的差别不只是「谁来接」,还决定了**佣金率什么时候被钉住**:
 * 直派单在下单那一刻快照,放池单要等抢单成交(S-06)才有承运商、才能快照。
 * 所以放池单的 commissionRateBpSnapshot 在下单后是 null —— 那不是漏写,是还没成交。
 * 「null 是漏写还是没成交」这件事必须由 dispatchMode 判定,不能靠猜。
 */
export const DISPATCH_MODE = ['designated', 'pool'] as const

export type DispatchMode = (typeof DISPATCH_MODE)[number]

export function isDispatchMode(x: unknown): x is DispatchMode {
  return typeof x === 'string' && (DISPATCH_MODE as readonly string[]).includes(x)
}
